import React, { useState, useEffect, useContext } from 'react';
import { Button, Form, Select, Space, DatePicker, Input, Modal, Divider, Typography } from 'antd';
import Axios from 'axios';
import Moment from 'moment';
import Lodash from 'lodash';

import * as COM from '.';
import * as Antd from 'antd';
import { AuthContext } from '../../containers/App';

const FiltersSaveModalForm = (props) => {
  const [form] = Form.useForm();
  return (
    <Modal
      title="Save filters"
      visible={props.visible}
      onCancel={() => {
        form.resetFields();
        if (props.onCancel) {
          props.onCancel();
        }
      }}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            form.resetFields();
            if (props.onOk) {
              props.onOk(values);
            }
          })
          .catch(info => {
            console.log('Validate Failed:', info);
          });
      }}
      okText="Save"
      cancelText="Cancel"
    >
      <Form
        form={form}
      >
        <Form.Item name="filterName" label="Filter name">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export const DatasetFilters = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState([]);
  const [filtersSaveModalFormVisible, setFiltersSaveModalFormVisible] = useState(false);
  const [savedFilters, setSavedFilters] = useState([]);
  let auth = useContext(AuthContext);

  const fetchColumns = async () => {
    try {
      let response = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/datasets`, {
        params: {
          filter: {
            where: {
              code: props.dataset
            }
          }
        }
      });
      setFilters(response.data[0].filters);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };

  const fetchSavedFilters = async () => {
    const key = `datagrid_filters_${props.connector}_${props.dataset}`;
    if (localStorage.getItem(key)) {
      setSavedFilters(JSON.parse(localStorage.getItem(key)));
    }
  };

  const saveFilters = async (name, data) => {
    const key = `datagrid_filters_${props.connector}_${props.dataset}`;
    let filtersToSave = savedFilters.concat([{ name, data }]);
    localStorage.setItem(key, JSON.stringify(filtersToSave));
    setSavedFilters(filtersToSave);
  }

  const fetchAll = async () => {
    setLoading(true);
    await fetchColumns();
    await fetchSavedFilters();
    setLoading(false);
  }

  useEffect(() => {
    fetchAll();
  }, []);

  const layout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 17 },
  };

  const tailLayout = {
    wrapperCol: { offset: 7, span: 17 },
  };

  const cleanEmptyOrUndefined = (obj) => {
    for (let key of Object.keys(obj)) {
      let value = obj[key];
      let type = typeof value;
      // clean empty object only but not moment instance
      if (type === "object" && !(value instanceof Moment) && value !== null && !Array.isArray(value)) {
        cleanEmptyOrUndefined(value);
        if (!Object.keys(value).length) {
          delete obj[key]
        }
        // clean empty array only
      } else if (Array.isArray(value) && value.length < 1) {
        delete obj[key];
        // clean undefined or null
      } else if (type === "undefined" || value === null) {
        delete obj[key];
      }
    }
  }

  const onFinish = (confirmedFilters) => {
    cleanEmptyOrUndefined(confirmedFilters);
    props.onChange(confirmedFilters);
  }

  const getFormItemByFilter = (filter, idx) => {
    if (filter.type === 'input') {
      return (
        <Form.Item
          key={idx}
          label={filter.title}
          name={filter.fieldName.split('.')}
          tooltip={filter.tooltip || filter.tooltip !== "" ? filter.tooltip : null}
          help={filter.help || filter.help !== "" ? filter.help : null}
        >
          <Antd.Input
            size="small"
            allowClear={filter.allowClear}
            disabled={filter.changeRoles && filter.changeRoles.length > 0
              && (Lodash.intersection(auth.userProfile.roles, filter.changeRoles).length < 1
                && Lodash.intersection(auth.userProfile.roles, ['ADMIN']).length < 1)}
          />
        </Form.Item>
      );
    }
    if (filter.type === 'select') {
      return (
        <Form.Item
          key={idx}
          label={filter.title}
          name={filter.fieldName.split('.')}
          tooltip={filter.tooltip || filter.tooltip !== "" ? filter.tooltip : null}
          help={filter.help || filter.help !== "" ? filter.help : null}
        >
          <Select
            size="small"
            allowClear={filter.allowClear}
            mode={filter.multiple ? 'multiple' : null}
            disabled={filter.changeRoles && filter.changeRoles.length > 0
              && (Lodash.intersection(auth.userProfile.roles, filter.changeRoles).length < 1
                && Lodash.intersection(auth.userProfile.roles, ['ADMIN']).length < 1)}
          >
            {filter.options.map((option, idx) =>
              <Select.Option key={idx} value={option.value}>{option.title}</Select.Option>
            )}
          </Select>
        </Form.Item>
      );
    }
    if (filter.type === 'datasetSelect') {
      return (
        <Form.Item
          key={idx}
          label={filter.title}
          name={[...filter.fieldName.split('.')]}
          tooltip={filter.tooltip || filter.tooltip !== "" ? filter.tooltip : null}
          help={filter.help || filter.help !== "" ? filter.help : null}
        >
          <COM.DatasetSelect
            size='small'
            allowClear={filter.allowClear}
            multiple={filter.multiple}
            connector={filter.connector}
            dataset={filter.dataset}
            filters={filter.filters !== ""
              ? JSON.parse(filter.filters)
              : {}} // TODO            
            disabled={filter.changeRoles && filter.changeRoles.length > 0
              && (Lodash.intersection(auth.userProfile.roles, filter.changeRoles).length < 1
                && Lodash.intersection(auth.userProfile.roles, ['ADMIN']).length < 1)}
          />
        </Form.Item>
      );
    }
    // if (filter.type === 'datasetGridSelect') {
    //   return (
    //     <Form.Item
    //       key={1}
    //       label={filter.title}
    //       name={filter.fieldName.split('.')}
    //     >
    //       <COM.DatasetGridSelect
    //         size="small"
    //         allowClear={filter.allowClear}
    //         multiple={filter.multiple}
    //         connector={filter.connector}
    //         dataset={filter.dataset}
    //         filters={{}}
    //       />
    //     </Form.Item>
    //   );
    // }
    if (filter.type === 'datasetTreeSelect') {
      return (
        <Form.Item
          key={idx}
          label={filter.title}
          name={[...filter.fieldName.split('.')]}
          tooltip={filter.tooltip || filter.tooltip !== "" ? filter.tooltip : null}
          help={filter.help || filter.help !== "" ? filter.help : null}
        >
          <COM.DatasetTreeSelect
            size='small'
            allowClear={filter.allowClear}
            multiple={filter.multiple}
            connector={filter.connector}
            dataset={filter.dataset}
            disabled={filter.changeRoles && filter.changeRoles.length > 0
              && (Lodash.intersection(auth.userProfile.roles, filter.changeRoles).length < 1
                && Lodash.intersection(auth.userProfile.roles, ['ADMIN']).length < 1)}
            filters={filter.filters !== ""
              ? JSON.parse(filter.filters)
              : {}}
          />
        </Form.Item>
      );
    }
    if (filter.type === 'dateRange') {
      return (
        <Form.Item
          key={idx}
          label={filter.title}
          name={[...filter.fieldName.split('.')]}
          tooltip={filter.tooltip || filter.tooltip !== "" ? filter.tooltip : null}
          help={filter.help || filter.help !== "" ? filter.help : null}
        >
          <COM.DateRange
            size='small'
            allowClear={filter.allowClear}
            disabled={filter.changeRoles && filter.changeRoles.length > 0
              && (Lodash.intersection(auth.userProfile.roles, filter.changeRoles).length < 1
                && Lodash.intersection(auth.userProfile.roles, ['ADMIN']).length < 1)}
          />
        </Form.Item>
      );
    }
  }

  return (
    <>
      <Typography.Title
        level={5}
      >
        Saved filters
      </Typography.Title>
      <Select
        style={{ width: '100%' }}
        onChange={(e) => {
          form.resetFields();
          form.setFieldsValue(JSON.parse(e));
        }}
      >
        {savedFilters.map((child, idx) => <Select.Option key={idx} value={JSON.stringify(child.data)}>{child.name}</Select.Option>)}
      </Select>
      <Antd.Divider />
      <Typography.Title
        level={5}
      >
        Filter settings
      </Typography.Title>
      <Form
        {...layout}
        name="filters"
        form={form}
        onFinish={onFinish}
        initialValues={props.initialValues}
      >
        {Lodash.sortBy(filters, ['order']).map((child, idx) => getFormItemByFilter(child, idx))}
        <Antd.Divider />
        <Form.Item {...tailLayout}>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
            >
              OK
            </Button>
            <Button
              onClick={() => {
                setFiltersSaveModalFormVisible(true);
              }}
            >
              Save
            </Button>
            {/* <Button
              onClick={() => {
                props.onChange(props.initialFilters);
                form.resetFields();
                form.setFieldsValue(props.initialFilters);
              }}
            >
              Clear
            </Button> */}
          </Space>
        </Form.Item>
      </Form>
      <FiltersSaveModalForm
        visible={filtersSaveModalFormVisible}
        onCancel={() => {
          setFiltersSaveModalFormVisible(false);
        }}
        onOk={(values) => {
          form
            .validateFields()
            .then((data) => {
              saveFilters(values.filterName, data);
            });
        }}
      />
    </>
  );
};
